import { Tags } from "../types";
import config from "../config";
import { useScadaPlusQuery } from "./useScadaPlusQuery";
import { getEnvConfig } from "env";

export const useGetTags = () => {
  return useScadaPlusQuery<Tags>(
    `tags`,
    `${getEnvConfig("API_URL")}/api/${config.api.tags}`,
  );
};
